export default "__VITE_ASSET__a36ebe4c__"